import React, { useRef, useState, useEffect } from 'react';
import { useDriverRegisterMutation } from '../../../redux/api/driverApi'
import { Link, useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import MetaData from '../../layout/MetaData'
import ReCAPTCHA from 'react-google-recaptcha';
import '../../../css/register.css';

const SITE_KEY = process.env.REACT_APP_SITE_KEY;

const RegisterDriver = () => {

    const [user, setUser] = useState({
      name: '',
      phoneNo: '',
      password: '',
      driverVehicleCapacity: '', 
      driverVehicleMakeModel: '', 
      driverVehicleNumber: '', 
      vehicle: 'Suzuki',
      latitude: null,
      longitude: null,
    });

      const [recaptchaValue, setRecaptchaValue] = useState('');
      const [termsAccepted, setTermsAccepted] = useState(false); // New state for terms acceptance
      const captchaRef = useRef();

      const { name, phoneNo, password, driverVehicleCapacity, driverVehicleMakeModel, driverVehicleNumber, vehicle, latitude, longitude } = user;
      
      const navigate = useNavigate();
      
      const [driverRegister, { isLoading, error, data }] = useDriverRegisterMutation();
      
      const { isAuthenticated } = useSelector((state) => state.auth);

  // Fetch the user's current location
  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const { latitude, longitude } = position.coords;
          setUser((prevUser) => ({
            ...prevUser,
            latitude,
            longitude,
          }));
        },
        (error) => {
          console.error('Error fetching location:', error);
          toast.error('براہ کرم اپنی ڈیوائس کی لوکیشن آن کریں۔');
        }
      );
    } else {
      toast.error('براہ کرم اپنی ڈیوائس کی لوکیشن آن کریں۔');
    }
  }, []);

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/');
      toast.error("logout to access this resource")
    }
    if (error) {
      toast.error(error?.data?.message,);
    }
    if (data) {
      navigate('/driver/verify-phone');
      // navigate('/driver/login');
    }
  }, [error, isAuthenticated, data, navigate]);

    // Handle input changes for name, email, phoneNo, password
    const onInputChange = (e) => {
      setUser({ ...user, [e.target.name]: e.target.value });


    };
    

      // Handle ReCAPTCHA token
  const onRecaptchaChange = (token) => {
    setRecaptchaValue(token);
  };

  // Handle form submission
  const submitHandler = (e) => {
    e.preventDefault();

    const signUpData = {
        name,
        phoneNo,
        password,
        driverVehicleCapacity,
        driverVehicleMakeModel,
        driverVehicleNumber,
        vehicle,
        latitude,
        longitude,
        recaptchaValue,
        termsAndAgreement: termsAccepted,
    };

    
  // ✅ Save phone number in localStorage
  localStorage.setItem("pendingDriverPhone", phoneNo);

    driverRegister(signUpData);
    captchaRef.current.reset();
};

  return (
    <>
      <MetaData title="Register" />
      <div className="row wrapper">
        <div className="col-10 col-lg-5">
          <form className="shadow rounded bg-body" onSubmit={submitHandler}>
            <h1 className="mb-4">ڈرائیورکا اکاؤنٹ  بنائیں</h1>

            <div className="mb-3">
              <label htmlFor="name_field" className="form-label">
              <h3>نام درج کریں</h3>
              </label>
              <input
                type="text"
                id="name_field"
                className="form-control"
                name="name"
                value={name}
                onChange={onInputChange}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="phoneNo_field" className="form-label">
              <h3>فون نمبر درج کریں</h3>
              </label>
              <input
                type="tel"
                id="phoneNo_field"
                className="form-control"
                name="phoneNo"
                value={phoneNo}
                onChange={onInputChange}
                maxLength={11}
                required
              />
            </div>

            <div className="mb-3">
              <label htmlFor="password_field" className="form-label">
              <h3>پاس ورڈدرج کریں</h3>
              </label>
              <input
                type="password"
                id="password_field"
                className="form-control"
                name="password"
                value={password}
                onChange={onInputChange}
                required
              />
            </div>

            <div className="mb-3 col">
                <label htmlFor="vehicle_field" className="form-label">
                <h3>گاڑی </h3>
                </label>
                <select
                  className="form-select"
                  id="vehicle_field"
                  name="vehicle"
                  defaultValue="Suzuki"
                  value={vehicle}
                  onChange={onInputChange}
                  required
                >
                 <option value="Suzuki">Suzuki</option>
                 <option value="Mazda">Mazda</option>
                 <option value="Shehzore">Shehzore</option>
                 {/* <option value="Truck 20ft">Truck 20ft</option>
                 <option value="Truck 40ft">Truck 40ft</option> */}
                </select>
              </div> 

              <div className="mb-3">
          <label htmlFor="driverVehicleNumber_field" className="form-label">
          <h3> گاڑی کانمبر</h3>
          </label>
          <input
            type="text"
            id="driverVehicleNumber_field"
            className="form-control"
            name="driverVehicleNumber"
            value={driverVehicleNumber}
            required
            onChange={onInputChange}
          />
        </div>

          <div className="mb-3">
          <label htmlFor="driverVehicleMakeModel_field" className="form-label">
          <h3>گاڑی کا میک ماڈل</h3>
          </label>
          <input
            type="text"
            id="driverVehicleMakeModel_field"
            className="form-control"
            name="driverVehicleMakeModel"
            value={driverVehicleMakeModel}
            required
            onChange={onInputChange}
          />
        </div>

          <div className="mb-3">
          <label htmlFor="totalWeight_field" className="form-label">
          <h3>گاڑی کی صلاحیت </h3>
          </label>
          <div className="input-group">
          <span className="input-group-text">KG's</span>
          <input
  type="number"
  id="driverVehicleCapacity_field"
  className="form-control"
  name="driverVehicleCapacity" // Correct
  value={driverVehicleCapacity}
  required
  onChange={onInputChange}
  maxLength={9}
/>
    </div>
  </div>
 

            <div className="mb-3">
              <div className="form-check">
                <input
                  type="checkbox"
                  className="form-check-input"
                  id="termsCheck"
                  checked={termsAccepted}
                  onChange={(e) => setTermsAccepted(e.target.checked)} // Update state on change
                />
                <label className="form-check-label" htmlFor="termsCheck">
                <h4>  میں <Link to="/Terms-And-Agreement">شرائط </Link>کو قبول کرتا ہوں۔ </h4>
                </label>
              </div>
            </div>

            <div className="form-group mt-2">
              <ReCAPTCHA
                sitekey={SITE_KEY}
                onChange={onRecaptchaChange}
                ref={captchaRef}
                id="captcha-register"
              />
            </div>

            <button
              id="register_button"
              type="submit"
              className="btn w-100 py-2"
              disabled={isLoading}
            >
              {isLoading ? 'Creating...' : 'REGISTER'}
            </button>

            <br />
            <br />

            <Link to="/login">Already have an account?</Link>
          </form>
        </div>
      </div>
     
    </>
  )
}

export default RegisterDriver
